module.exports = "<input type=\"text\"\n    ng-model=\"displayedUnits\"\n    value=\"{{displayedUnits}}\"\n    (keyup)=\"onKey($event)\">\n"


//////////////////
// WEBPACK FOOTER
// ./~/text-loader!./_src/ui/elements/composeNumber.html
// module id = 509
// module chunks = 1 4